import { render, staticRenderFns } from "./fixedBottomComponents.vue?vue&type=template&id=48845fbb&scoped=true"
import script from "./fixedBottomComponents.vue?vue&type=script&lang=js"
export * from "./fixedBottomComponents.vue?vue&type=script&lang=js"
import style0 from "./fixedBottomComponents.vue?vue&type=style&index=0&id=48845fbb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48845fbb",
  null
  
)

export default component.exports